import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/tvShows';

export default function CategoryNav() {
  const [activeCategory, setActiveCategory] = useState('all');

  return (
    <section className="w-full bg-background-50 border-b border-background-200/70">
      <div className="w-full px-4 md:px-6 py-5">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-4 overflow-x-auto scrollbar-hide">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                onClick={() => setActiveCategory(cat.slug)}
                className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all shrink-0 cursor-pointer whitespace-nowrap ${
                  activeCategory === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200/70'
                }`}
              >
                <i className={`${cat.icon} text-base w-4 h-4 flex items-center justify-center`}></i>
                <span>{cat.name}</span>
                <span className={`text-xs ${activeCategory === cat.slug ? 'text-background-50/70' : 'text-foreground-400'}`}>
                  {cat.count}
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}